import React, { useState, useEffect } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import {  Link } from "react-router-dom";
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/user-1.jpg"
import { getUserProfileImageUrl } from "../../../helpers/auth_api"

interface ProfileMenuProps {
  t: (key: string) => string
  error?: any
  success?: any
}

const ProfileMenu: React.FC<ProfileMenuProps> = (props) => {
  const [menu, setMenu] = useState(false)
  const [profileImg, setProfileImg] = useState<string>(user1)

  const refreshProfileImg = () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (authUser) {
        const obj = JSON.parse(authUser)
        const url = getUserProfileImageUrl(obj)
        setProfileImg(url || user1)
      } else {
        setProfileImg(user1)
      }
    } catch {
      setProfileImg(user1)
    }
  }

  useEffect(() => {
    refreshProfileImg()
    const onProfileUpdated = () => refreshProfileImg()
    window.addEventListener("focus", refreshProfileImg)
    window.addEventListener("profileUpdated", onProfileUpdated)
    return () => {
      window.removeEventListener("focus", refreshProfileImg)
      window.removeEventListener("profileUpdated", onProfileUpdated)
    }
  }, [])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={profileImg}
            alt="Header Avatar"
            referrerPolicy="no-referrer"
            crossOrigin="anonymous"
            onError={(e) => {
              if (e.currentTarget.src !== user1) e.currentTarget.src = user1
            }}
          />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/profile">
            {" "}
            <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1"/>
            {props.t("Profile")}{" "}
          </DropdownItem>
       
    
          <div className="dropdown-divider"/>
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger"/>
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

const mapStatetoProps = (state: any) => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)